import { ListTimelineEntriesQuery } from '../../../types/__generated__';
import useFullPageQuery from '../useFullPageQuery';
import query from './queries/listTimelineEntries.gql';
import { useMeasurementSystem } from './useMeasurementSystem';
import { useTimelineEntryType } from './useTimelineEntryType';

export function useListTimelineEntries() {
  const measurementSystem = useMeasurementSystem();
  // B2C_048 - show hide fitness data
  // EntryType can be removed when experiment has ended
  // or added as a non experiment test if successful
  const { entryType } = useTimelineEntryType();
  return useFullPageQuery<ListTimelineEntriesQuery>(query, {
    variables: { measurementSystem, entryType },
    context: {
      credentials: 'include',
    },
  });
}
